<div class="container">
    <div class="card border-primary p-1 p-md-4">
        <div class="card-body row">
            <div class="col-12 col-md-4">
                <app-shadow-dom-encapsulate>
                    <div class="d-flex justify-content-center">
                        <svg-icon
                            [svgClass]="'w-md-75 svg-colors'"
                            [src]="
                                'registration-webinar-logo'
                                    | cmsImageSrc
                                    | async
                            "
                            [svgAriaLabel]="
                                'registration-webinar-logo'
                                    | cmsImageAlt
                                    | async
                            "
                        ></svg-icon>
                    </div>
                </app-shadow-dom-encapsulate>
                <div
                    *ngIf="showVideo$ | async"
                    class="d-none d-md-flex justify-content-center"
                >
                    <div class="w-75">
                        <div
                            class="mt-3 embed-responsive rounded ratio ratio-16x9"
                            [youtubemovie]="
                                'webinar-youtube-video' | cmsText | async
                            "
                        ></div>
                        <div
                            class="text-center"
                            [innerHTML]="
                                'webinar-youtube-video-title'
                                    | cmsText
                                        : [
                                              {
                                                  community:
                                                      (community$ | async),
                                              },
                                          ]
                                    | jpText
                                    | async
                            "
                        ></div>
                    </div>
                </div>
            </div>
            <div class="col mx-3">
                <h4>
                    <span
                        class="d-block mt-3 mt-md-1 d-md-none"
                        [innerHTML]="
                            'registration-webinar-title'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></span>
                    <span
                        class="hr d-none d-md-inline-block"
                        [innerHTML]="
                            'registration-webinar-title'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></span
                    ><span
                        class="mt-2 m-md-3 badge bg-primary"
                        [innerHTML]="'webinar-badge' | cmsText | jpText | async"
                    ></span>
                    <hr class="webinar-hr d-md-none" />
                </h4>
                <span
                    class="my-3"
                    [innerHTML]="
                        'registration-webinar-second-title'
                            | cmsText
                            | jpText
                            | async
                    "
                ></span>
                <h6
                    class="my-3"
                    [innerHTML]="
                        'registration-webinar-on-demand-schedule'
                            | cmsText
                            | jpText
                            | async
                    "
                ></h6>
                <div
                    *ngIf="showVideo$ | async"
                    class="d-flex d-md-none justify-content-center"
                >
                    <div class="w-100">
                        <div
                            class="mt-3 embed-responsive rounded ratio ratio-16x9"
                            [youtubemovie]="
                                'webinar-youtube-video' | cmsText | async
                            "
                        ></div>
                        <div
                            class="text-center"
                            [innerHTML]="
                                'webinar-youtube-video-title'
                                    | cmsText
                                        : [
                                              {
                                                  community:
                                                      (community$ | async),
                                              },
                                          ]
                                    | jpText
                                    | async
                            "
                        ></div>
                    </div>
                </div>
                <div class="row">
                    <!-- Left col -->
                    <div class="d-inline col-12 col-md my-2 me-md-2">
                        <div class="alert alert-info p-1 pe-md-5 h-100">
                            <div
                                class=""
                                [innerHTML]="
                                    'registration-webinar-registration-content'
                                        | cmsText
                                        | jpText
                                        | async
                                "
                            ></div>
                            <div *ngIf="isRegistrationButtonUrlFilled$ | async">
                                <div class="button-wrapper btn-container">
                                    <a
                                        target="_blank"
                                        [href]="
                                            'registration-webinar-registration-button-url'
                                                | cmsText
                                                | async
                                        "
                                        class="btn btn-outline-primary px-5 text-md-left text-center"
                                    >
                                        {{
                                            'registration-webinar-registration-button-text'
                                                | cmsText
                                                | async
                                        }}
                                    </a>
                                </div>
                                <span class="text-grey">{{
                                    'registration-webinar-registration-footer-message'
                                        | cmsText
                                        | async
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- right col -->
                    <div class="d-inline col-12 col-md my-2 ms-md-2">
                        <div
                            class="alert alert-info p-1"
                            [ngClass]="{
                                'h-100': isAcceptationButtonUrlFilled$ | async,
                            }"
                        >
                            <span
                                class=""
                                [innerHTML]="
                                    'registration-webinar-acceptation-content'
                                        | cmsText
                                        | jpText
                                        | async
                                "
                            ></span>
                            <div *ngIf="isAcceptationButtonUrlFilled$ | async">
                                <div class="button-wrapper btn-container">
                                    <a
                                        target="_blank"
                                        [href]="
                                            'registration-webinar-acceptation-button-url'
                                                | cmsText
                                                | async
                                        "
                                        class="btn btn-outline-primary px-5 text-md-left text-center"
                                    >
                                        {{
                                            'registration-webinar-acceptation-button-text'
                                                | cmsText
                                                | async
                                        }}
                                    </a>
                                </div>
                                <span class="text-grey">{{
                                    'registration-webinar-acceptation-footer-message'
                                        | cmsText
                                        | async
                                }}</span>
                            </div>
                        </div>
                        <div *ngIf="!(isAcceptationButtonUrlFilled$ | async)">
                            {{
                                'registration-webinar-acceptation-message'
                                    | cmsText
                                    | async
                            }}
                        </div>
                    </div>
                </div>

                <div class="btn-container-left">
                    <a
                        [routerLink]="'../info/about-webinars'"
                        id="home-about-webinars-button"
                        class="btn btn-outline-primary px-5 text-md-left text-center"
                    >
                        {{ 'webinars-button-text' | cmsText | async }}
                        <span class="fa fa-chevron-right"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
